/* Product catalog for ProductDetailPage - all imports must be static */
/* Bags & Traditional removed — client will add via Dashboard later */

/* Gold Bracelets */
import gb1a from "../assets/gold-bracelet1.2.png";
import gb1b from "../assets/gold-bracelet1.1.png";
import gb1c from "../assets/gold-bracelet1.jpeg";
import gb2a from "../assets/gold-bracelet2.jpeg";
import gb2b from "../assets/gold-bracelet2.1.png";
import gb2c from "../assets/gold-bracelet2.2.png";
import gb3a from "../assets/gold-bracelet3.jpeg";
import gb3b from "../assets/gold-bracelet3.1.jpg";
import gb3c from "../assets/gold-bracelet3.2.jpg";
import gb4a from "../assets/gold-bracelet4.jpeg";
import gb4b from "../assets/gold-bracelet4.1.jpg";
import gb4c from "../assets/gold-bracelet4.2.png";

/* Cuff Bracelets */
import cb1 from "../assets/cuff-bracelet1.jpeg";
import cb2 from "../assets/cuff-bracelet2.jpeg";
import cb3 from "../assets/cuff-bracelet3.jpeg";

/* Gold Kada */
import k1a from "../assets/kada1.jpeg";
import k1b from "../assets/kada1.1.png";
import k1c from "../assets/kada1.2.png";
import k2 from "../assets/kada2.jpeg";
import k3 from "../assets/kada3.jpg";
import k4 from "../assets/kada4.jpeg";

/* Bangles */
import baAnti from "../assets/anti-tarnish-bangle1.jpeg";
import baBrass1 from "../assets/brass-gold-bangle1.jpeg";
import baBrass2 from "../assets/brass-gold-bangle2.jpeg";
import baFancy from "../assets/unique-bangle1.jpeg";

/* Pendants */
import p1 from "../assets/pendant1.jpeg";
import p2 from "../assets/pendant2.jpeg";
import p3 from "../assets/pendant3.jpeg";
import p4 from "../assets/pendant4.jpeg";
import p5 from "../assets/pendant5.jpeg";
import p6 from "../assets/pendant6.jpeg";
import p7 from "../assets/pendant7.jpeg";
import p8 from "../assets/pendant8.jpeg";

/* Chokers */
import ch1 from "../assets/choker1.jpg";
import ch2 from "../assets/choker2.jpg";
import ch3 from "../assets/choker3.jpg";

/* Earrings */
import eStud1 from "../assets/stud1.jpeg";
import eStud2 from "../assets/stud2.jpeg";
import eStud3 from "../assets/stud3.jpeg";
import eMona1 from "../assets/monalisa1.jpeg";
import eMona2 from "../assets/monalisa2.jpeg";
import eMona3 from "../assets/monalisa3.jpeg";
import eMona4 from "../assets/monalisa4.jpeg";
import eMona5 from "../assets/monalisa5.jpeg";
import eMona6 from "../assets/monalisa6.jpeg";
import eHoop1 from "../assets/hoop1.jpeg";

/* Ring */
import r1 from "../assets/ring1.jpeg";

/* American Diamond Stone Necklaces */
import adGold1 from "../assets/ad-gold1.jpg";
import adGold2 from "../assets/ad-gold2.jpg";
import adGold3 from "../assets/ad-gold3.jpg";
import adGold4 from "../assets/ad-gold4.jpg";
import adGold5 from "../assets/ad-gold5.jpg";
import adGold6 from "../assets/ad-gold6.jpg";
import adSilver1 from "../assets/ad-silver1.jpg";
import adSilver2 from "../assets/ad-silver2.jpg";
import adSilver3 from "../assets/ad-silver3.jpg";
import adSilver4 from "../assets/ad-silver4.jpg";
import adSilver5 from "../assets/ad-silver5.jpg";
import adSilver6 from "../assets/ad-silver6.jpg";

/* Matching Necklace + Earrings Sets */
import nSet1 from "../assets/matching1.jpg";

/* ✅ CZ Stone Necklaces (NEW) */
import czGold1 from "../assets/cz1.jpg";
import czGold2 from "../assets/cz2.jpg";
import czGold3 from "../assets/cz3.jpg";
import czGold4 from "../assets/cz4.jpg";
import czSilver1 from "../assets/cz-silver1.jpg";
import czSilver2 from "../assets/cz-silver2.jpg";
import czCircle1 from "../assets/ad-circle1.jpg";
import czCircle2 from "../assets/ad-circle2.jpg";

/* Shared similar products (bracelets/kada) */
const braceletSimilar = [
  { name: "AYRINE Bubble style gold tone bracelet", price: 249, img: gb2a, link: "/gold-bracelet-2" },
  { name: "AYRINE Black clover bracelet for party wear", price: 259, img: gb3a, link: "/gold-bracelet-3" },
  { name: "AYRINE Gold plated Nail bracelet for girls", price: 319, img: gb4a, link: "/gold-bracelet-4" },
  { name: "AYRINE Geometric gold spiral cuff kada", price: 279, img: cb1, link: "/cuff-bracelet-1" },
  { name: "AYRINE wraparound bracelet", price: 349, img: cb2, link: "/cuff-bracelet-2" },
  { name: "AYRINE Gold toned multi layered bracelet & bangle for women's & girls", price: 399, img: cb3, link: "/cuff-bracelet-3" },
  { name: "AYRINE Ocean curve gold plated kada/cuff", price: 399, img: k1a, link: "/gold-kada-1" },
  { name: "AYRINE round golden kada for girls & women's", price: 449, img: k2, link: "/gold-kada-2" },
  { name: "AYRINE Gold pleated cuff kada for girls", price: 499, img: k3, link: "/gold-kada-3" },
  { name: "AYRINE 5 layer flexible stretch coil bracelet", price: 549, img: k4, link: "/gold-kada-4" },
];

const pendantSimilar = [
  { name: "AYRINE popping heart zircon diamond chain-pendant", price: 149, img: p2, link: "/necklace-pendant-2" },
  { name: "AYRINE Bow cute butterfly chain-pendant", price: 149, img: p3, link: "/necklace-pendant-3" },
  { name: "AYRINE crystal clover chain-pendant", price: 149, img: p5, link: "/necklace-pendant-5" },
  { name: "AYRINE Victorian pearl choker set", price: 1499, img: ch1, link: "/choker-1" },
  { name: "AYRINE elegant water drop Mona Lisa earrings", price: 119, img: eMona1, link: "/monalisa-1" },
];

const chokerSimilar = [
  { name: "AYRINE vintage natural diamond chain-pendant", price: 149, img: p1, link: "/necklace-pendant-1" },
  { name: "AYRINE crystal clover chain-pendant", price: 149, img: p5, link: "/necklace-pendant-5" },
  { name: "AYRINE green Kundan white beads choker set", price: 1499, img: ch2, link: "/choker-2" },
  { name: "AYRINE Elegant fresh water pearl choker set", price: 1499, img: ch3, link: "/choker-3" },
];

const earringSimilar = [
  { name: "AYRINE white shiny shell pearl Mona Lisa earrings", price: 119, img: eMona2, link: "/monalisa-2" },
  { name: "AYRINE combo of 3 pair gold plated hoop earrings", price: 149, img: eStud1, link: "/stud-1" },
  { name: "AYRINE Twisted gold style big hoop earrings", price: 99, img: eHoop1, link: "/hoop-1" },
  { name: "AYRINE love ring with 3 diamonds", price: 99, img: r1, link: "/ring-1" },
];

const bangleSimilar = [
  { name: "AYRINE golden brass imitation dailywear bangles", price: 199, img: baAnti, link: "/bangle-anti-1" },
  { name: "AYRINE Delicate Australian stone Bangles", price: 249, img: baBrass1, link: "/bangle-brass-1" },
  { name: "AYRINE Brass kadli design dailywear bangles", price: 249, img: baBrass2, link: "/bangle-brass-2" },
  { name: "AYRINE fancy fine work premium bangles", price: 249, img: baFancy, link: "/bangle-fancy-1" },
];

const ringSimilar = [
  { name: "AYRINE elegant water drop Mona Lisa earrings", price: 119, img: eMona1, link: "/monalisa-1" },
  { name: "AYRINE vintage natural diamond chain-pendant", price: 149, img: p1, link: "/necklace-pendant-1" },
  { name: "AYRINE Twisted gold style big hoop earrings", price: 99, img: eHoop1, link: "/hoop-1" },
];

const adNecklaceSimilar = [
  { name: "AYRINE trending AD stone pink gold plated necklace", price: 699, img: adGold2, link: "/ad-gold-2" },
  { name: "AYRINE Victorian pearl choker set", price: 1499, img: ch1, link: "/choker-1" },
  { name: "AYRINE elegant water drop Mona Lisa earrings", price: 119, img: eMona1, link: "/monalisa-1" },
];

const czSimilar = [
  { name: "AYRINE Gold tone flower CZ necklace", price: 1099, img: czGold1, link: "/cz-gold-1" },
  { name: "AYRINE Silver tone flower CZ necklace", price: 1099, img: czSilver1, link: "/cz-silver-1" },
  { name: "AYRINE American Diamond circle necklace", price: 749, img: czCircle1, link: "/cz-circle-1" },
  { name: "AYRINE Floral CZ stone chain necklace (Gold)", price: 1099, img: czGold3, link: "/cz-gold-3" },
];

export const PRODUCTS = {
  "gold-bracelet-1": {
    id: "gold-bracelet-1",
    images: [gb1a, gb1b, gb1c],
    title: "AYRINE jewellery Style craft butterfly bracelet for girls",
    description: "Minimal, elegant and perfect for everyday styling. Crafted with precision and finished with anti-tarnish polish.",
    originalPrice: 349,
    offerPrice: 249,
    similarProducts: braceletSimilar,
  },
  "gold-bracelet-2": {
    id: "gold-bracelet-2",
    images: [gb2a, gb2b, gb2c],
    title: "AYRINE Bubble style gold tone bracelet",
    description: "Bold yet graceful with a modern circular design that elevates any outfit effortlessly.",
    originalPrice: 349,
    offerPrice: 249,
    similarProducts: braceletSimilar,
  },
  "gold-bracelet-3": {
    id: "gold-bracelet-3",
    images: [gb3a, gb3b, gb3c],
    title: "AYRINE Black clover bracelet for party wear",
    description: "Designed to add sophistication and charm to your festive and party looks.",
    originalPrice: 349,
    offerPrice: 249,
    similarProducts: braceletSimilar,
  },
  "gold-bracelet-4": {
    id: "gold-bracelet-4",
    images: [gb4a, gb4b, gb4c],
    title: "AYRINE Gold plated Nail bracelet for girls",
    description: "Inspired by contemporary luxury trends with a sleek nail-inspired silhouette.",
    originalPrice: 349,
    offerPrice: 249,
    similarProducts: braceletSimilar,
  },
  "gold-kada-1": {
    id: "gold-kada-1",
    images: [k1a, k1b, k1c],
    title: "AYRINE Ocean curve gold plated kada/cuff",
    description: "Featuring a flowing curved design that reflects modern elegance and grace.",
    originalPrice: 349,
    offerPrice: 249,
    similarProducts: braceletSimilar,
  },
  "gold-kada-2": {
    id: "gold-kada-2",
    images: [k2, k2, k2],
    title: "AYRINE round golden kada for girls & women's",
    description: "A classic circular design that blends tradition with modern simplicity.",
    originalPrice: 349,
    offerPrice: 249,
    similarProducts: braceletSimilar,
  },
  "gold-kada-3": {
    id: "gold-kada-3",
    images: [k3, k3, k3],
    title: "AYRINE Gold pleated cuff kada for girls",
    description: "Sleek and bold with a contemporary open cuff silhouette.",
    originalPrice: 349,
    offerPrice: 249,
    similarProducts: braceletSimilar,
  },
  "gold-kada-4": {
    id: "gold-kada-4",
    images: [k4, k4, k4],
    title: "AYRINE 5 layer flexible stretch coil bracelet",
    description: "Designed with layered coils for a bold and stylish stacked look.",
    originalPrice: 349,
    offerPrice: 249,
    similarProducts: braceletSimilar,
  },
  "cuff-bracelet-1": {
    id: "cuff-bracelet-1",
    images: [cb1, cb1, cb1],
    title: "AYRINE Geometric gold spiral cuff kada",
    description: "A striking geometric spiral design that adds a modern artistic touch.",
    originalPrice: 399,
    offerPrice: 279,
    similarProducts: braceletSimilar,
  },
  "cuff-bracelet-2": {
    id: "cuff-bracelet-2",
    images: [cb2, cb2, cb2],
    title: "AYRINE wraparound bracelet",
    description: "Chic wraparound style that creates a layered look in a single piece.",
    originalPrice: 399,
    offerPrice: 349,
    similarProducts: braceletSimilar,
  },
  "cuff-bracelet-3": {
    id: "cuff-bracelet-3",
    images: [cb3, cb3, cb3],
    title: "AYRINE Gold toned multi layered bracelet & bangle for women's & girls",
    description: "Multi-layered texture design for a bold and fashionable statement.",
    originalPrice: 399,
    offerPrice: 399,
    similarProducts: braceletSimilar,
  },
  "bangle-anti-1": {
    id: "bangle-anti-1",
    images: [baAnti, baAnti, baAnti],
    title: "AYRINE golden brass imitation dailywear bangles",
    description: "Anti-tarnish gold plated bangles for everyday elegance. Crafted with precision for lasting shine.",
    originalPrice: 399,
    offerPrice: 199,
    similarProducts: bangleSimilar,
  },
  "bangle-brass-1": {
    id: "bangle-brass-1",
    images: [baBrass1, baBrass1, baBrass1],
    title: "AYRINE Delicate Australian stone Bangles",
    description: "Elegant brass gold bangles with delicate stone work. Perfect for traditional and contemporary looks.",
    originalPrice: 399,
    offerPrice: 249,
    similarProducts: bangleSimilar,
  },
  "bangle-brass-2": {
    id: "bangle-brass-2",
    images: [baBrass2, baBrass2, baBrass2],
    title: "AYRINE Brass kadli design dailywear bangles",
    description: "Classic kadli design in brass gold finish. Timeless appeal for daily wear.",
    originalPrice: 399,
    offerPrice: 249,
    similarProducts: bangleSimilar,
  },
  "bangle-fancy-1": {
    id: "bangle-fancy-1",
    images: [baFancy, baFancy, baFancy],
    title: "AYRINE fancy fine work premium bangles",
    description: "Premium bangles with intricate fine work. A statement piece for special occasions.",
    originalPrice: 399,
    offerPrice: 249,
    similarProducts: bangleSimilar,
  },
  "necklace-pendant-1": {
    id: "necklace-pendant-1",
    images: [p1, p1, p1],
    title: "AYRINE vintage natural diamond chain-pendant",
    description: "Vintage-inspired pendant with natural diamond accents. Elegant and timeless.",
    originalPrice: 249,
    offerPrice: 149,
    similarProducts: pendantSimilar,
  },
  "necklace-pendant-2": {
    id: "necklace-pendant-2",
    images: [p2, p2, p2],
    title: "AYRINE popping heart zircon diamond chain-pendant",
    description: "Adorable heart-shaped pendant with zircon diamond sparkle. Perfect for everyday glamour.",
    originalPrice: 249,
    offerPrice: 149,
    similarProducts: pendantSimilar,
  },
  "necklace-pendant-3": {
    id: "necklace-pendant-3",
    images: [p3, p3, p3],
    title: "AYRINE Bow cute butterfly chain-pendant",
    description: "Cute butterfly design with bow details. A charming addition to your jewellery collection.",
    originalPrice: 249,
    offerPrice: 149,
    similarProducts: pendantSimilar,
  },
  "necklace-pendant-4": {
    id: "necklace-pendant-4",
    images: [p4, p4, p4],
    title: "AYRINE gold bow cute diamond tie chain-pendant",
    description: "Gold bow design with diamond tie accents. Delicate and feminine.",
    originalPrice: 249,
    offerPrice: 149,
    similarProducts: pendantSimilar,
  },
  "necklace-pendant-5": {
    id: "necklace-pendant-5",
    images: [p5, p5, p5],
    title: "AYRINE crystal clover chain-pendant",
    description: "Lucky clover design with crystal sparkle. A symbol of elegance and charm.",
    originalPrice: 249,
    offerPrice: 149,
    similarProducts: pendantSimilar,
  },
  "necklace-pendant-6": {
    id: "necklace-pendant-6",
    images: [p6, p6, p6],
    title: "AYRINE cute gold doubled heart chain pendant",
    description: "Double heart pendant in gold tone. A perfect gift for someone special.",
    originalPrice: 249,
    offerPrice: 149,
    similarProducts: pendantSimilar,
  },
  "necklace-pendant-7": {
    id: "necklace-pendant-7",
    images: [p7, p7, p7],
    title: "AYRINE emerald diamond flurr chain pendant",
    description: "Emerald-inspired pendant with diamond flourishes. Bold and beautiful.",
    originalPrice: 249,
    offerPrice: 149,
    similarProducts: pendantSimilar,
  },
  "necklace-pendant-8": {
    id: "necklace-pendant-8",
    images: [p8, p8, p8],
    title: "AYRINE diamond butterfly chain pendant",
    description: "Elegant butterfly pendant with diamond accents. Graceful and refined.",
    originalPrice: 249,
    offerPrice: 149,
    similarProducts: pendantSimilar,
  },
  "choker-1": {
    id: "choker-1",
    images: [ch1, ch1, ch1],
    title: "AYRINE Victorian pearl choker set",
    description: "Victorian-inspired pearl choker set. Timeless elegance for special occasions.",
    originalPrice: 1999,
    offerPrice: 1499,
    similarProducts: chokerSimilar,
  },
  "choker-2": {
    id: "choker-2",
    images: [ch2, ch2, ch2],
    title: "AYRINE green Kundan white beads choker set",
    description: "Kundan and bead choker set in green and white. Traditional meets contemporary.",
    originalPrice: 1999,
    offerPrice: 1499,
    similarProducts: chokerSimilar,
  },
  "choker-3": {
    id: "choker-3",
    images: [ch3, ch3, ch3],
    title: "AYRINE Elegant fresh water pearl choker set",
    description: "Fresh water pearl choker set. Understated luxury for any occasion.",
    originalPrice: 1999,
    offerPrice: 1499,
    similarProducts: chokerSimilar,
  },
  "ad-gold-1": {
    id: "ad-gold-1",
    images: [adGold1, adGold1, adGold1],
    title: "AYRINE trending AD stone purple gold plated necklace",
    description: "Trending American Diamond stone necklace in purple gold plating. Elegant and eye-catching.",
    originalPrice: 899,
    offerPrice: 699,
    similarProducts: adNecklaceSimilar,
  },
  "ad-gold-2": {
    id: "ad-gold-2",
    images: [adGold2, adGold2, adGold2],
    title: "AYRINE trending AD stone pink gold plated necklace",
    description: "Trending American Diamond stone necklace in pink gold plating. Perfect for special occasions.",
    originalPrice: 899,
    offerPrice: 699,
    similarProducts: adNecklaceSimilar,
  },
  "ad-gold-3": {
    id: "ad-gold-3",
    images: [adGold3, adGold3, adGold3],
    title: "AYRINE trending AD stone baby pink gold plated necklace",
    description: "Trending American Diamond stone necklace in baby pink gold plating. Delicate and stylish.",
    originalPrice: 899,
    offerPrice: 699,
    similarProducts: adNecklaceSimilar,
  },
  "ad-gold-4": {
    id: "ad-gold-4",
    images: [adGold4, adGold4, adGold4],
    title: "AYRINE trending AD stone blue gold plated necklace",
    description: "Trending American Diamond stone necklace in blue gold plating. Bold and beautiful.",
    originalPrice: 899,
    offerPrice: 699,
    similarProducts: adNecklaceSimilar,
  },
  "ad-gold-5": {
    id: "ad-gold-5",
    images: [adGold5, adGold5, adGold5],
    title: "AYRINE trending AD stone white gold plated necklace",
    description: "Trending American Diamond stone necklace in white gold plating. Classic elegance.",
    originalPrice: 899,
    offerPrice: 699,
    similarProducts: adNecklaceSimilar,
  },
  "ad-gold-6": {
    id: "ad-gold-6",
    images: [adGold6, adGold6, adGold6],
    title: "AYRINE trending AD stone black gold plated necklace",
    description: "Trending American Diamond stone necklace in black gold plating. Statement piece.",
    originalPrice: 899,
    offerPrice: 699,
    similarProducts: adNecklaceSimilar,
  },
  "ad-silver-1": {
    id: "ad-silver-1",
    images: [adSilver1, adSilver1, adSilver1],
    title: "AYRINE trending AD stone blue silver plated necklace",
    description: "Trending American Diamond stone necklace in blue silver plating. Cool and elegant.",
    originalPrice: 899,
    offerPrice: 699,
    similarProducts: adNecklaceSimilar,
  },
  "ad-silver-2": {
    id: "ad-silver-2",
    images: [adSilver2, adSilver2, adSilver2],
    title: "AYRINE trending AD stone green silver plated necklace",
    description: "Trending American Diamond stone necklace in green silver plating. Fresh and modern.",
    originalPrice: 899,
    offerPrice: 699,
    similarProducts: adNecklaceSimilar,
  },
  "ad-silver-3": {
    id: "ad-silver-3",
    images: [adSilver3, adSilver3, adSilver3],
    title: "AYRINE trending AD baby pink silver plated necklace",
    description: "Trending American Diamond baby pink silver plated necklace. Soft and feminine.",
    originalPrice: 899,
    offerPrice: 699,
    similarProducts: adNecklaceSimilar,
  },
  "ad-silver-4": {
    id: "ad-silver-4",
    images: [adSilver4, adSilver4, adSilver4],
    title: "AYRINE trending AD stone pink silver plated necklace",
    description: "Trending American Diamond stone necklace in pink silver plating. Elegant and versatile.",
    originalPrice: 899,
    offerPrice: 699,
    similarProducts: adNecklaceSimilar,
  },
  "ad-silver-5": {
    id: "ad-silver-5",
    images: [adSilver5, adSilver5, adSilver5],
    title: "AYRINE trending AD stone white silver plated necklace",
    description: "Trending American Diamond stone necklace in white silver plating. Timeless appeal.",
    originalPrice: 899,
    offerPrice: 699,
    similarProducts: adNecklaceSimilar,
  },
  "ad-silver-6": {
    id: "ad-silver-6",
    images: [adSilver6, adSilver6, adSilver6],
    title: "AYRINE trending AD stone black silver plated necklace",
    description: "Trending American Diamond stone necklace in black silver plating. Bold and chic.",
    originalPrice: 899,
    offerPrice: 699,
    similarProducts: adNecklaceSimilar,
  },
  "n-set-1": {
    id: "n-set-1",
    images: [nSet1, nSet1, nSet1],
    title: "Noor Matching Set",
    description: "Elegant matching necklace and earrings set. Perfect coordinated look for any occasion.",
    originalPrice: 999,
    offerPrice: 799,
    similarProducts: pendantSimilar,
  },
  "monalisa-1": {
    id: "monalisa-1",
    images: [eMona1, eMona1, eMona1],
    title: "AYRINE elegant water drop Mona Lisa earrings",
    description: "Elegant water drop design Mona Lisa earrings. Classic style with modern appeal.",
    originalPrice: 249,
    offerPrice: 119,
    similarProducts: earringSimilar,
  },
  "monalisa-2": {
    id: "monalisa-2",
    images: [eMona2, eMona2, eMona2],
    title: "AYRINE white shiny shell pearl Mona Lisa earrings",
    description: "White shell pearl Mona Lisa earrings. Shimmering elegance for everyday wear.",
    originalPrice: 249,
    offerPrice: 119,
    similarProducts: earringSimilar,
  },
  "monalisa-3": {
    id: "monalisa-3",
    images: [eMona3, eMona3, eMona3],
    title: "AYRINE gold pearl studded Mona Lisa earrings",
    description: "Gold pearl studded Mona Lisa earrings. A touch of luxury for any outfit.",
    originalPrice: 249,
    offerPrice: 119,
    similarProducts: earringSimilar,
  },
  "monalisa-4": {
    id: "monalisa-4",
    images: [eMona4, eMona4, eMona4],
    title: "AYRINE off white drop Mona Lisa earrings",
    description: "Off white drop Mona Lisa earrings. Soft and sophisticated.",
    originalPrice: 249,
    offerPrice: 119,
    similarProducts: earringSimilar,
  },
  "monalisa-5": {
    id: "monalisa-5",
    images: [eMona5, eMona5, eMona5],
    title: "AYRINE gold plated Mona Lisa earrings",
    description: "Gold plated Mona Lisa earrings. Timeless design with lasting shine.",
    originalPrice: 249,
    offerPrice: 119,
    similarProducts: earringSimilar,
  },
  "monalisa-6": {
    id: "monalisa-6",
    images: [eMona6, eMona6, eMona6],
    title: "AYRINE indo western gold Mona Lisa earrings",
    description: "Indo western gold Mona Lisa earrings. Fusion of traditional and contemporary.",
    originalPrice: 249,
    offerPrice: 119,
    similarProducts: earringSimilar,
  },
  "stud-1": {
    id: "stud-1",
    images: [eStud1, eStud1, eStud1],
    title: "AYRINE combo of 3 pair gold plated hoop earrings",
    description: "Combo of 3 pair gold plated hoop earrings. Versatile styles for every mood.",
    originalPrice: 249,
    offerPrice: 149,
    similarProducts: earringSimilar,
  },
  "stud-2": {
    id: "stud-2",
    images: [eStud2, eStud2, eStud2],
    title: "AYRINE combo of 3 pair heart dolphin earrings",
    description: "Combo of 3 pair heart and dolphin earrings. Playful and charming.",
    originalPrice: 249,
    offerPrice: 149,
    similarProducts: earringSimilar,
  },
  "stud-3": {
    id: "stud-3",
    images: [eStud3, eStud3, eStud3],
    title: "AYRINE combo of 3 pair sea shell-swan earrings",
    description: "Combo of 3 pair sea shell and swan earrings. Nautical elegance.",
    originalPrice: 249,
    offerPrice: 149,
    similarProducts: earringSimilar,
  },
  "hoop-1": {
    id: "hoop-1",
    images: [eHoop1, eHoop1, eHoop1],
    title: "AYRINE Twisted gold style big hoop earrings",
    description: "Twisted gold style big hoop earrings. Bold statement for any occasion.",
    originalPrice: 199,
    offerPrice: 99,
    similarProducts: earringSimilar,
  },
  "ring-1": {
    id: "ring-1",
    images: [r1, r1, r1],
    title: "AYRINE love ring with 3 diamonds, Anti-tarnish & waterproof",
    description: "Love ring with 3 diamonds. Anti-tarnish and waterproof for everyday wear.",
    originalPrice: 199,
    offerPrice: 99,
    similarProducts: ringSimilar,
  },
  "cz-gold-1": {
    id: "cz-gold-1",
    images: [czGold1, czGold1, czGold1],
    title: "AYRINE Gold tone flower CZ necklace",
    description: "Warm gold tone with floral sparkle — perfect for festive and daily glam.",
    originalPrice: 1499,
    offerPrice: 1099,
    similarProducts: czSimilar,
  },
  "cz-gold-2": {
    id: "cz-gold-2",
    images: [czGold2, czGold2, czGold2],
    title: "AYRINE Gold bloom CZ pendant necklace",
    description: "Warm gold tone with floral sparkle — perfect for festive and daily glam.",
    originalPrice: 1499,
    offerPrice: 1099,
    similarProducts: czSimilar,
  },
  "cz-gold-3": {
    id: "cz-gold-3",
    images: [czGold3, czGold3, czGold3],
    title: "AYRINE Floral CZ stone chain necklace (Gold)",
    description: "Warm gold tone with floral sparkle — perfect for festive and daily glam.",
    originalPrice: 1499,
    offerPrice: 1099,
    similarProducts: czSimilar,
  },
  "cz-gold-4": {
    id: "cz-gold-4",
    images: [czGold4, czGold4, czGold4],
    title: "AYRINE Petal shine CZ necklace (Gold tone)",
    description: "Warm gold tone with floral sparkle — perfect for festive and daily glam.",
    originalPrice: 1499,
    offerPrice: 1099,
    similarProducts: czSimilar,
  },
  "cz-silver-1": {
    id: "cz-silver-1",
    images: [czSilver1, czSilver1, czSilver1],
    title: "AYRINE Silver tone flower CZ necklace",
    description: "Cool silver sparkle with delicate flower design — elegant and minimal.",
    originalPrice: 1499,
    offerPrice: 1099,
    similarProducts: czSimilar,
  },
  "cz-silver-2": {
    id: "cz-silver-2",
    images: [czSilver2, czSilver2, czSilver2],
    title: "AYRINE Silver floral CZ chain necklace",
    description: "Cool silver sparkle with delicate flower design — elegant and minimal.",
    originalPrice: 1499,
    offerPrice: 1099,
    similarProducts: czSimilar,
  },
  "cz-circle-1": {
    id: "cz-circle-1",
    images: [czCircle1, czCircle1, czCircle1],
    title: "AYRINE American Diamond circle necklace",
    description: "Classic circle motif with diamond-like shine — timeless and premium.",
    originalPrice: 999,
    offerPrice: 749,
    similarProducts: czSimilar,
  },
  "cz-circle-2": {
    id: "cz-circle-2",
    images: [czCircle2, czCircle2, czCircle2],
    title: "AYRINE Circular AD pendant necklace",
    description: "Classic circle motif with diamond-like shine — timeless and premium.",
    originalPrice: 999,
    offerPrice: 749,
    similarProducts: czSimilar,
  },
};

// Bags & Traditional products removed — client will add later via Dashboard
// Object.assign(PRODUCTS, BAGS_TRADITIONAL_PRODUCTS);

export function getProductById(productId) {
  return PRODUCTS[productId] || null;
}
